import React from "react";
import { Icon } from "../designSystem";

export const ErrorPage = ({ error }) => {
  return (
    <div className="lt-center-state">
      <Icon name="error" size={36} style={{ color: "var(--danger)" }} />
      <p style={{ color: "var(--danger)" }}>
        {typeof error === "string" ? error : "加载失败，请稍后重试。"}
      </p>
    </div>
  );
};
